import { FormErrorFocus } from 'components';
import { useTranslation } from 'libs/i18n';
import { DocumentsTableFeature } from 'modules/client/common/feature';

import { Legal } from './Legal';
import { Representative } from './Representative';

export const FormContent = () => {
  const { t } = useTranslation();

  return (
    <>
      <FormErrorFocus />
      <Legal />
      <Representative />
      <DocumentsTableFeature
        maxDocumentCount={1}
        name="companySignedClientServiceAgreementFiles"
        title={t('client.createLegalClient.contract')}
        titleVariant="subtitle"
      />
      <DocumentsTableFeature
        maxDocumentCount={1}
        name="companySignedNoticeOfInvestmentAccountOpeningFiles"
        title={t(
          'client.createLegalClient.companySignedNoticeOfInvestmentAccountOpening'
        )}
        titleVariant="subtitle"
      />
    </>
  );
};
